module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/General/Smile-11c7f4e85b26895704edbabe1c1a807960f8a5fc6046419c17de61b5943cea57.svg";